import React,{useRef} from "react";
import CSS from "./About.module.css";
import icInsta from '../../assets/Images/ic_insta.png';
import icYoutube from '../../assets/Images/ic_youtube.png';

const AboutUs = () => {
  const sectionRef = useRef(null);

  return (
    <div ref={sectionRef} className={CSS.About}>
      
      <div className={CSS.AboutRow + " row"}>

        <div className={CSS.blank + " col-md-2"}></div>

        {/* Location */}
        <div className={CSS.location + " col-md-2"}>
          <div><i className={"material-icons " + CSS.increase}>location_on</i></div>
          <div>324, Ramgarh Engineering College</div>
          <div>Murubanda, Ramgarh, Jharkhand</div>
        </div>

        {/* Mail */}
        <div className={CSS.mail + " col-md-2"}>
          <div><i className={"material-icons " + CSS.increase}>mail</i></div>
          <div className={CSS.someLeft}>recstudentportal@gmail.com</div>
        </div>

        {/* Phone - removed previous numbers */}
        <div className={CSS.phone + " col-md-2"}>
          <div><i className={"material-icons " + CSS.increase}>phone</i></div>
          <div>+91-6200964848</div>
          <div>+91-7260014902</div>
        </div>

        {/* Social - Instagram + YouTube */}
        <div className={CSS.social + " col-md-2"}>
          <div className={CSS.icoImg}>
            <a href="https://instagram.com/recstudentportal" target="_blank" rel="noreferrer">
              <img style={{width:"28px",height:"28px"}} src={icInsta} alt="Instagram" />
            </a>

            <a
              href="https://youtube.com/@recstudentportal"
              target="_blank"
              rel="noreferrer"
              style={{ marginLeft: "12px" }}
            >
              <img
                style={{width:"28px",height:"28px"}}
                src={icYoutube}
                alt="YouTube"
              />
            </a>

            <div>recstudentportal</div>
          </div>
        </div>

        <div className={CSS.blank + " col-md-2"}></div>
      </div>

      {/* COPYRIGHT */}
      <div className={CSS.copyright}>
        &copy; REC Student Portal, {new Date().getFullYear()}
      </div>

    </div>
  );
};

export default AboutUs;
